var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AdminForm',{attrs:{"config":_vm.config,"form":_vm.form,"isBusy":_vm.isBusy,"options":_vm.options},on:{"submit:update:success":_vm.updateSucess}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6f3117b1","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/RentingPreparation/RentingPreparationForm.vue
// module id = 932
// module chunks = 0